import request from '@/utils/request'

// 查询订单-组局信息列表
export function listGroup(query) {
  return request({
    url: '/order/group/list',
    method: 'get',
    params: query
  })
}

// 查询订单-组局信息详细
export function getGroup(id) {
  return request({
    url: '/order/group/' + id,
    method: 'get'
  })
}

// 新增订单-组局信息
export function addGroup(data) {
  return request({
    url: '/order/group',
    method: 'post',
    data: data
  })
}

// 修改订单-组局信息
export function updateGroup(data) {
  return request({
    url: '/order/group',
    method: 'put',
    data: data
  })
}

// 删除订单-组局信息
export function delGroup(id) {
  return request({
    url: '/order/group/' + id,
    method: 'delete'
  })
}

// 获取价格
export function getPrice(params) {
  return request({
    url: '/order/group/price',
    method: 'post',
    data: params
  })
}
